import { TradingStats } from '@server/data-feed/schemas/output.schema';
import { StatsFieldMap } from '../../../foundation/shared/components/stats';

export const statsFieldMap: StatsFieldMap<TradingStats> = {
  pnl: { label: 'PnL', type: 'number', formatting: 'amountChange' },
  totalTrades: { label: 'Total trades', type: 'quantity' },
  winLossRatio: {
    label: 'Winning/Losing',
    type: 'custom',
    customValue: (stats) => `${stats.winningTrades}/${stats.loosingTrades}`
  },
  winRatio: { label: 'Win ratio', type: 'percent' },
  commission: { label: 'Commission', type: 'number' },
  totalWinAmount: {
    label: 'Total win',
    type: 'number',
    formatting: 'amountChange'
  },
  totalLossAmount: {
    label: 'Total loss',
    type: 'number',
    formatting: 'amountChange'
  },
  profitFactor: { label: 'Profit factor', type: 'number' },
  highestProfit: {
    label: 'Highest profit',
    type: 'custom',
    customValue: (stats) =>
      `${stats.highestProfitValue.toFixed(
        2
      )} (${stats.highestProfitPercent.toFixed(2)}%)`,
    formatting: 'amountChange',
    valueKey: 'highestProfitValue'
  },
  highestProfitDate: { label: 'Highest profit date', type: 'date' },
  highestDrawdown: {
    label: 'Highest drawdown',
    type: 'custom',
    customValue: (stats) =>
      `${stats.highestDrawdownValue.toFixed(
        2
      )} (${stats.highestDrawdownPercent.toFixed(2)}%)`,
    formatting: 'amountChange',
    valueKey: 'highestDrawdownValue'
  },
  highestDrawdownDate: { label: 'Highest drawdown date', type: 'date' }
};
